<template>
  <div class="logomaker">
      <div id="wait" v-if="wait">
        <span>
          <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        </span>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-4 bg-light sidebar">
          <div class="sidebar-container">
            <div class="logo">
              <img src="../assets/onlinecreation.png" alt="onlinecreation.me">
              <h1><strong>dessine-moi</strong> un <strong>logo</strong></h1>
            </div>
            <div class="form">
              <input type="text" class="form-control" v-model="company" placeholder="Company name">
              <select class='form-control font' id="fontCompany" v-model="fontCompany">
              </select>
              <div class="form-group row">
                <label for="companyColor" class="col-sm-6 col-form-label">Couleur</label>
                <div class="col-sm-6">
                  <input type='color' class='color form-control' id='companyColor' value="#000000" v-model="colorCompany"></label>
                </div>
              </div>
              <div class="small-margin"></div>
              <input type="text" class="form-control" v-model="slogan" placeholder="Company's slogan">
              <select class='form-control font' v-model="fontSlogan" id="fontSlogan">
              </select>
              <div class="form-group row">
                <label for="sloganColor" class="col-sm-6 col-form-label">Couleur</label>
                <div class="col-sm-6">
                  <input type='color' class='color form-control' id='sloganColor' value="#000000" v-model="colorSlogan"></label>
                </div>
              </div>
              <div class="small-margin"></div>
              <div class="logo-frame">
                <div class="picto">
                  <ul>
                    <li v-for="icon in icons">
                      <label><input type="radio" v-model="logo" name="logo" v-bind:value="icon"><i v-bind:class="icon"></i> {{ icon }}</label></li>
                  </ul>
                </div>
              </div>
              <div class="form-group row">
                <label for="colorLogo" class="col-sm-6 col-form-label">Couleur</label>
                <div class="col-sm-6">
                  <input type='color' class='color form-control' id='logoColor' value="#000000" v-model="colorLogo"></label>
                </div>
              </div>
              <select class="form-control" v-model="alignLogo">
                <option value="left">Pictogramme à gauche</option>
                <option value="right">Pictogramme à droite</option>
                <option value="center">Pictogramme au dessus</option>
              </select>
              <div class="small-margin"></div>
              <div class="text-center">
                <a href="#" class="btn btn-primary" @click="save('logo-oven')"><i class="icofont icofont-download-alt"></i> Télécharger</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-8 workspace gradient-pattern">
          <div id="logo-oven" :class="alignLogo">
            <i class="icofont-5x fa-5x" :class="logo" :style="{ color: colorLogo }"></i>
            <span class="company" :style="{ fontFamily: fontCompany, color: colorCompany }">{{ company }}</span><br>
            <span class="slogan" :style="{ fontFamily: fontSlogan, color: colorSlogan }">{{ slogan }}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import $ from 'jquery'
require('select2/dist/js/select2.full.js')
require('higooglefonts/js/fonts.js')
require('../assets/icofont/css/icofont.css')
require('font-awesome/css/font-awesome.css')
require('select2/dist/css/select2.css')
require('higooglefonts/css/fonts.css')

export default {
  name: 'logo',
  data () {
    return {
      company: 'Mon projet',
      slogan: 'Avec une accroche',
      fontCompany: 'ABeeZee',
      fontSlogan: 'ABeeZee',
      colorCompany: '#333333',
      colorSlogan: '#333333',
      colorLogo: '#333333',
      alignLogo: 'left',
      logo: 'icofont icofont-sun',
      wait: false,
      icons: [
        'icofont icofont-ui-office',
        'icofont icofont-ui-password',
        'icofont icofont-ui-pause',
        'icofont icofont-ui-play',
        'icofont icofont-ui-play-stop',
        'icofont icofont-ui-pointer',
        'icofont icofont-ui-power',
        'icofont icofont-ui-press',
        'icofont icofont-ui-previous',
        'icofont icofont-ui-rate-add',
        'icofont icofont-ui-rate-blank',
        'icofont icofont-ui-rate-remove',
        'icofont icofont-ui-rating',
        'icofont icofont-ui-record',
        'icofont icofont-ui-remove',
        'icofont icofont-ui-reply',
        'icofont icofont-ui-rotation',
        'icofont icofont-ui-rss',
        'icofont icofont-ui-search',
        'icofont icofont-ui-settings',
        'icofont icofont-ui-social-link',
        'icofont icofont-ui-tag',
        'icofont icofont-ui-text-chat',
        'icofont icofont-ui-text-loading',
        'icofont icofont-ui-theme',
        'icofont icofont-ui-timer',
        'icofont icofont-ui-touch-phone',
        'icofont icofont-ui-travel',
        'icofont icofont-ui-unlock',
        'icofont icofont-ui-user',
        'icofont icofont-ui-user-group',
        'icofont icofont-ui-v-card',
        'icofont icofont-ui-video',
        'icofont icofont-ui-video-chat',
        'icofont icofont-ui-video-message',
        'icofont icofont-ui-video-play',
        'icofont icofont-ui-volume',
        'icofont icofont-ui-weather',
        'icofont icofont-ui-wifi',
        'icofont icofont-ui-zoom-in',
        'icofont icofont-ui-zoom-out',
        'icofont icofont-cassette',
        'icofont icofont-cassette-player',
        'icofont icofont-forward',
        'icofont icofont-game',
        'icofont icofont-guiter',
        'icofont icofont-headphone-alt-1',
        'icofont icofont-headphone-alt-2',
        'icofont icofont-headphone-alt-3',
        'icofont icofont-listening',
        'icofont icofont-megaphone',
        'icofont icofont-megaphone-alt',
        'icofont icofont-movie',
        'icofont icofont-mp3-player',
        'icofont icofont-multimedia',
        'icofont icofont-music-disk',
        'icofont icofont-music-note',
        'icofont icofont-pause',
        'icofont icofont-play-alt-1',
        'icofont icofont-play-alt-2',
        'icofont icofont-play-alt-3',
        'icofont icofont-play-pause',
        'icofont icofont-record',
        'icofont icofont-retro-music-disk',
        'icofont icofont-rewind',
        'icofont icofont-song-notes',
        'icofont icofont-sound-wave',
        'icofont icofont-sound-wave-alt',
        'icofont icofont-stop',
        'icofont icofont-video-alt',
        'icofont icofont-video-cam',
        'icofont icofont-volume-bar',
        'icofont icofont-volume-mute',
        'icofont icofont-youtube-play',
        'icofont icofont-bank-transfer',
        'icofont icofont-bank-transfer-alt',
        'icofont icofont-braintree',
        'icofont icofont-braintree-alt',
        'icofont icofont-cash-on-delivery',
        'icofont icofont-cash-on-delivery-alt',
        'icofont icofont-checkout',
        'icofont icofont-checkout-alt',
        'icofont icofont-boy',
        'icofont icofont-business-man',
        'icofont icofont-business-man-alt-1',
        'icofont icofont-business-man-alt-2',
        'icofont icofont-business-man-alt-3',
        'icofont icofont-funky-man',
        'icofont icofont-girl',
        'icofont icofont-girl-alt',
        'icofont icofont-hotel-boy',
        'icofont icofont-hotel-boy-alt',
        'icofont icofont-man-in-glasses',
        'icofont icofont-user',
        'icofont icofont-user-alt-1',
        'icofont icofont-user-alt-2',
        'icofont icofont-user-alt-3',
        'icofont icofont-user-alt-4',
        'icofont icofont-user-alt-5',
        'icofont icofont-user-alt-6',
        'icofont icofont-user-alt-7',
        'icofont icofont-user-female',
        'icofont icofont-user-male',
        'icofont icofont-user-suited',
        'icofont icofont-users',
        'icofont icofont-users-alt-1',
        'icofont icofont-users-alt-2',
        'icofont icofont-users-alt-3',
        'icofont icofont-users-alt-4',
        'icofont icofont-users-alt-5',
        'icofont icofont-users-alt-6',
        'icofont icofont-users-social',
        'icofont icofont-waiter',
        'icofont icofont-woman-in-glasses',
        'icofont icofont-document-search',
        'icofont icofont-folder-search',
        'icofont icofont-home-search',
        'icofont icofont-job-search',
        'icofont icofont-map-search',
        'icofont icofont-restaurant-search',
        'icofont icofont-search',
        'icofont icofont-search-alt-1',
        'icofont icofont-search-alt-2',
        'icofont icofont-stock-search',
        'icofont icofont-user-search',
        'icofont icofont-badminton-birdie',
        'icofont icofont-baseball',
        'icofont icofont-baseballer',
        'icofont icofont-basketball',
        'icofont icofont-basketball-hoop',
        'icofont icofont-billiard-ball',
        'icofont icofont-boot-alt-1',
        'icofont icofont-boot-alt-2',
        'icofont icofont-bowling',
        'icofont icofont-bowling-alt',
        'icofont icofont-canoe',
        'icofont icofont-cheer-leader',
        'icofont icofont-climbing',
        'icofont icofont-corner',
        'icofont icofont-cyclist',
        'icofont icofont-dumbbell',
        'icofont icofont-dumbbell-alt',
        'icofont icofont-field',
        'icofont icofont-field-alt',
        'icofont icofont-football-alt',
        'icofont icofont-foul',
        'icofont icofont-goal',
        'icofont icofont-goal-keeper',
        'icofont icofont-golf',
        'icofont icofont-golf-alt',
        'icofont icofont-golf-bag',
        'icofont icofont-golf-field',
        'icofont icofont-golfer',
        'icofont icofont-gym',
        'icofont icofont-gym-alt-1',
        'icofont icofont-gym-alt-2',
        'icofont icofont-gym-alt-3',
        'icofont icofont-hand-grippers',
        'icofont icofont-heart-beat-alt',
        'icofont icofont-helmet',
        'icofont icofont-hockey',
        'icofont icofont-hockey-alt',
        'icofont icofont-ice-skate',
        'icofont icofont-jersey',
        'icofont icofont-jersey-alt',
        'icofont icofont-jumping',
        'icofont icofont-kick',
        'icofont icofont-leg',
        'icofont icofont-match-review',
        'icofont icofont-medal-alt',
        'icofont icofont-muscle',
        'icofont icofont-muscle-alt',
        'icofont icofont-offside',
        'icofont icofont-olympic',
        'icofont icofont-olympic-logo',
        'icofont icofont-padding',
        'icofont icofont-penalty-card',
        'icofont icofont-racer',
        'icofont icofont-racing-car',
        'icofont icofont-racing-flag',
        'icofont icofont-racing-flag-alt',
        'icofont icofont-racings-wheel',
        'icofont icofont-referee',
        'icofont icofont-refree-jersey',
        'icofont icofont-result',
        'icofont icofont-rugby',
        'icofont icofont-rugby-ball',
        'icofont icofont-rugby-player',
        'icofont icofont-runner',
        'icofont icofont-runner-alt-1',
        'icofont icofont-runner-alt-2',
        'icofont icofont-score-board',
        'icofont icofont-skiing-man',
        'icofont icofont-skydiving-goggles',
        'icofont icofont-snow-mobile',
        'icofont icofont-steering',
        'icofont icofont-substitute',
        'icofont icofont-swimmer',
        'icofont icofont-table-tennis',
        'icofont icofont-team',
        'icofont icofont-team-alt',
        'icofont icofont-tennis',
        'icofont icofont-tennis-player',
        'icofont icofont-time',
        'icofont icofont-track',
        'icofont icofont-tracking',
        'icofont icofont-trophy',
        'icofont icofont-trophy-alt',
        'icofont icofont-volleyball',
        'icofont icofont-volleyball-alt',
        'icofont icofont-volleyball-fire',
        'icofont icofont-water-bottle',
        'icofont icofont-whisle',
        'icofont icofont-win-trophy',
        'icofont icofont-align-center',
        'icofont icofont-align-left',
        'icofont icofont-align-right',
        'icofont icofont-all-caps',
        'icofont icofont-bold',
        'icofont icofont-brush',
        'icofont icofont-clip-board',
        'icofont icofont-code-alt',
        'icofont icofont-color-bucket',
        'icofont icofont-color-picker',
        'icofont icofont-copy-alt',
        'icofont icofont-copy-black',
        'icofont icofont-cut',
        'icofont icofont-delete-alt',
        'icofont icofont-edit-alt',
        'icofont icofont-eraser-alt',
        'icofont icofont-file-alt',
        'icofont icofont-font',
        'icofont icofont-header',
        'icofont icofont-indent',
        'icofont icofont-italic-alt',
        'icofont icofont-justify-all',
        'icofont icofont-justify-center',
        'icofont icofont-justify-left',
        'icofont icofont-justify-right',
        'icofont icofont-line-height',
        'icofont icofont-link-alt',
        'icofont icofont-listine-dots',
        'icofont icofont-listing-box',
        'icofont icofont-listing-number',
        'icofont icofont-marker',
        'icofont icofont-outdent',
        'icofont icofont-paper-clip',
        'icofont icofont-paragraph',
        'icofont icofont-pin',
        'icofont icofont-printer',
        'icofont icofont-redo',
        'icofont icofont-rotation',
        'icofont icofont-save',
        'icofont icofont-small-cap',
        'icofont icofont-strike-through',
        'icofont icofont-sub-listing',
        'icofont icofont-subscript',
        'icofont icofont-superscript',
        'icofont icofont-table',
        'icofont icofont-text-height',
        'icofont icofont-text-width',
        'icofont icofont-trash',
        'icofont icofont-underline',
        'icofont icofont-undo',
        'icofont icofont-unlink',
        'icofont icofont-air-balloon',
        'icofont icofont-airplane',
        'icofont icofont-airplane-alt',
        'icofont icofont-ambulance-crescent',
        'icofont icofont-ambulance-cross',
        'icofont icofont-articulated-truck',
        'icofont icofont-auto-rickshaw',
        'icofont icofont-bicycle-alt-1',
        'icofont icofont-bicycle-alt-2',
        'icofont icofont-bull-dozer',
        'icofont icofont-bus-alt-1',
        'icofont icofont-bus-alt-2',
        'icofont icofont-bus-alt-3',
        'icofont icofont-cable-car',
        'icofont icofont-car-alt-1',
        'icofont icofont-car-alt-2',
        'icofont icofont-car-alt-3',
        'icofont icofont-car-alt-4',
        'icofont icofont-concrete-mixer',
        'icofont icofont-delivery-time',
        'icofont icofont-excavator',
        'icofont icofont-fast-delivery',
        'icofont icofont-fire-truck',
        'icofont icofont-fire-truck-alt',
        'icofont icofont-fork-lift',
        'icofont icofont-free-delivery',
        'icofont icofont-golf-cart',
        'icofont icofont-helicopter',
        'icofont icofont-motor-bike',
        'icofont icofont-motor-bike-alt',
        'icofont icofont-motor-biker',
        'icofont icofont-oil-truck',
        'icofont icofont-police-car',
        'icofont icofont-rickshaw',
        'icofont icofont-rocket-alt-1',
        'icofont icofont-rocket-alt-2',
        'icofont icofont-sail-boat',
        'icofont icofont-scooter',
        'icofont icofont-sea-plane',
        'icofont icofont-ship-alt',
        'icofont icofont-speed-boat',
        'icofont icofont-taxi',
        'icofont icofont-tow-truck',
        'icofont icofont-tractor',
        'icofont icofont-traffic-light',
        'icofont icofont-train-line',
        'icofont icofont-train-steam',
        'icofont icofont-tram',
        'icofont icofont-truck',
        'icofont icofont-truck-alt',
        'icofont icofont-truck-loaded',
        'icofont icofont-van',
        'icofont icofont-van-alt',
        'icofont icofont-yacht',
        'icofont icofont-5-star-hotel',
        'icofont icofont-anchor-alt',
        'icofont icofont-beach-bed',
        'icofont icofont-camping-vest',
        'icofont icofont-coconut-alt',
        'icofont icofont-direction-sign',
        'icofont icofont-hill-side',
        'icofont icofont-island-alt',
        'icofont icofont-long-drive',
        'icofont icofont-map-pins',
        'icofont icofont-plane-ticket',
        'icofont icofont-sail-boat-alt-1',
        'icofont icofont-sail-boat-alt-2',
        'icofont icofont-sandals-female',
        'icofont icofont-sandals-male',
        'icofont icofont-travelling',
        'icofont icofont-breakdown',
        'icofont icofont-celsius',
        'icofont icofont-clouds',
        'icofont icofont-cloudy',
        'icofont icofont-compass-alt',
        'icofont icofont-dust',
        'icofont icofont-eclipse',
        'icofont icofont-fahrenheit',
        'icofont icofont-forest-fire',
        'icofont icofont-full-night',
        'icofont icofont-full-sunny',
        'icofont icofont-hail',
        'icofont icofont-hail-night',
        'icofont icofont-hail-rainy',
        'icofont icofont-hail-rainy-night',
        'icofont icofont-hail-rainy-sunny',
        'icofont icofont-hail-sunny',
        'icofont icofont-hail-thunder',
        'icofont icofont-hail-thunder-night',
        'icofont icofont-hail-thunder-sunny',
        'icofont icofont-hill',
        'icofont icofont-hill-night',
        'icofont icofont-hill-sunny',
        'icofont icofont-hurricane',
        'icofont icofont-island',
        'icofont icofont-meteor',
        'icofont icofont-night',
        'icofont icofont-rainy',
        'icofont icofont-rainy-night',
        'icofont icofont-rainy-sunny',
        'icofont icofont-rainy-thunder',
        'icofont icofont-showy-night-hail',
        'icofont icofont-snow',
        'icofont icofont-snow-temp',
        'icofont icofont-snowy',
        'icofont icofont-snowy-hail',
        'icofont icofont-snowy-night',
        'icofont icofont-snowy-night-rainy',
        'icofont icofont-snowy-rainy',
        'icofont icofont-snowy-sunny',
        'icofont icofont-snowy-sunny-hail',
        'icofont icofont-snowy-sunny-rainy',
        'icofont icofont-snowy-thunder',
        'icofont icofont-snowy-thunder-night',
        'icofont icofont-snowy-thunder-sunny',
        'icofont icofont-snowy-windy',
        'icofont icofont-snowy-windy-night',
        'icofont icofont-snowy-windy-sunny',
        'icofont icofont-sun-alt',
        'icofont icofont-sun-rise',
        'icofont icofont-sun-set',
        'icofont icofont-sunny',
        'icofont icofont-sunny-day-temp',
        'icofont icofont-thermometer',
        'icofont icofont-thinder-light',
        'icofont icofont-tornado',
        'icofont icofont-umbrella-alt',
        'icofont icofont-volcano',
        'icofont icofont-wave',
        'icofont icofont-wind',
        'icofont icofont-wind-scale-0',
        'icofont icofont-wind-scale-1',
        'icofont icofont-wind-scale-10',
        'icofont icofont-wind-scale-11',
        'icofont icofont-wind-scale-12',
        'icofont icofont-wind-scale-2',
        'icofont icofont-wind-scale-3',
        'icofont icofont-wind-scale-4',
        'icofont icofont-wind-scale-5',
        'icofont icofont-wind-scale-6',
        'icofont icofont-wind-scale-7',
        'icofont icofont-wind-scale-8',
        'icofont icofont-wind-scale-9',
        'icofont icofont-wind-waves',
        'icofont icofont-windy',
        'icofont icofont-windy-hail',
        'icofont icofont-windy-night',
        'icofont icofont-windy-raining',
        'icofont icofont-windy-sunny',
        'icofont icofont-windy-thunder',
        'icofont icofont-windy-thunder-raining',
        'icofont icofont-addons',
        'icofont icofont-address-book',
        'icofont icofont-adjust',
        'icofont icofont-alarm',
        'icofont icofont-anchor',
        'icofont icofont-archive',
        'icofont icofont-at',
        'icofont icofont-attachment',
        'icofont icofont-audio',
        'icofont icofont-auto-mobile',
        'icofont icofont-automation',
        'icofont icofont-baby',
        'icofont icofont-badge',
        'icofont icofont-bag',
        'icofont icofont-ban',
        'icofont icofont-bank',
        'icofont icofont-bar-code',
        'icofont icofont-bars',
        'icofont icofont-battery-empty',
        'icofont icofont-battery-full',
        'icofont icofont-battery-half',
        'icofont icofont-battery-low',
        'icofont icofont-beach',
        'icofont icofont-beaker',
        'icofont icofont-bear',
        'icofont icofont-beard',
        'icofont icofont-bed',
        'icofont icofont-bell',
        'icofont icofont-beverage',
        'icofont icofont-bicycle',
        'icofont icofont-bill',
        'icofont icofont-bin',
        'icofont icofont-binary',
        'icofont icofont-binoculars',
        'icofont icofont-bird',
        'icofont icofont-birds',
        'icofont icofont-black-board',
        'icofont icofont-bluetooth',
        'icofont icofont-bolt',
        'icofont icofont-bomb',
        'icofont icofont-book',
        'icofont icofont-book-mark',
        'icofont icofont-boot',
        'icofont icofont-box',
        'icofont icofont-brain',
        'icofont icofont-briefcase',
        'icofont icofont-broken',
        'icofont icofont-bucket',
        'icofont icofont-bucket1',
        'icofont icofont-bucket2',
        'icofont icofont-bug',
        'icofont icofont-building',
        'icofont icofont-bullet',
        'icofont icofont-bullhorn',
        'icofont icofont-bullseye',
        'icofont icofont-bus',
        'icofont icofont-butterfly',
        'icofont icofont-cab',
        'icofont icofont-calculator',
        'icofont icofont-calendar',
        'icofont icofont-camera',
        'icofont icofont-camera-alt',
        'icofont icofont-car',
        'icofont icofont-card',
        'icofont icofont-cart',
        'icofont icofont-cc',
        'icofont icofont-certificate',
        'icofont icofont-charging',
        'icofont icofont-chat',
        'icofont icofont-check',
        'icofont icofont-check-alt',
        'icofont icofont-check-circled',
        'icofont icofont-checked',
        'icofont icofont-children-care',
        'icofont icofont-clock-time',
        'icofont icofont-close',
        'icofont icofont-close-circled',
        'icofont icofont-close-line',
        'icofont icofont-close-line-circled',
        'icofont icofont-close-line-squared',
        'icofont icofont-close-line-squared-alt',
        'icofont icofont-close-squared',
        'icofont icofont-close-squared-alt',
        'icofont icofont-cloud',
        'icofont icofont-cloud-download',
        'icofont icofont-cloud-refresh',
        'icofont icofont-cloud-upload',
        'icofont icofont-code',
        'icofont icofont-code-not-allowed',
        'icofont icofont-coffee-cup',
        'icofont icofont-comment',
        'icofont icofont-compass',
        'icofont icofont-computer',
        'icofont icofont-connection',
        'icofont icofont-console',
        'icofont icofont-contacts',
        'icofont icofont-contrast',
        'icofont icofont-copy',
        'icofont icofont-copyright',
        'icofont icofont-credit-card',
        'icofont icofont-crop',
        'icofont icofont-crown',
        'icofont icofont-cube',
        'icofont icofont-cubes',
        'icofont icofont-culinary',
        'icofont icofont-dashboard',
        'icofont icofont-dashboard-web',
        'icofont icofont-data',
        'icofont icofont-database',
        'icofont icofont-database-add',
        'icofont icofont-database-locked',
        'icofont icofont-database-remove',
        'icofont icofont-delete',
        'icofont icofont-diamond',
        'icofont icofont-dice',
        'icofont icofont-disabled',
        'icofont icofont-disc',
        'icofont icofont-diskette',
        'icofont icofont-document-folder',
        'icofont icofont-download',
        'icofont icofont-download-alt',
        'icofont icofont-downloaded',
        'icofont icofont-earth',
        'icofont icofont-ebook',
        'icofont icofont-edit',
        'icofont icofont-eject',
        'icofont icofont-email',
        'icofont icofont-envelope',
        'icofont icofont-envelope-open',
        'icofont icofont-eraser',
        'icofont icofont-error',
        'icofont icofont-exchange',
        'icofont icofont-exclamation',
        'icofont icofont-exclamation-circle',
        'icofont icofont-exclamation-square',
        'icofont icofont-exclamation-tringle',
        'icofont icofont-exit',
        'icofont icofont-expand',
        'icofont icofont-external',
        'icofont icofont-external-link',
        'icofont icofont-eye',
        'icofont icofont-eye-blocked',
        'icofont icofont-eye-dropper',
        'icofont icofont-favourite',
        'icofont icofont-fax',
        'icofont icofont-female',
        'icofont icofont-file',
        'icofont icofont-film',
        'icofont icofont-filter',
        'icofont icofont-fire',
        'icofont icofont-fire-burn',
        'icofont icofont-fire-extinguisher',
        'icofont icofont-first-aid',
        'icofont icofont-flag',
        'icofont icofont-flag-alt-1',
        'icofont icofont-flag-alt-2',
        'icofont icofont-flash',
        'icofont icofont-flash-light',
        'icofont icofont-flask',
        'icofont icofont-focus',
        'icofont icofont-folder',
        'icofont icofont-folder-open',
        'icofont icofont-foot-print',
        'icofont icofont-football',
        'icofont icofont-football-american',
        'icofont icofont-game-console',
        'icofont icofont-game-pad',
        'icofont icofont-gavel',
        'icofont icofont-gear',
        'icofont icofont-gears',
        'icofont icofont-gift',
        'icofont icofont-glass',
        'icofont icofont-globe',
        'icofont icofont-graduate',
        'icofont icofont-graffiti',
        'icofont icofont-grocery',
        'icofont icofont-group',
        'icofont icofont-hammer',
        'icofont icofont-hand',
        'icofont icofont-hanger',
        'icofont icofont-hard-disk',
        'icofont icofont-headphone',
        'icofont icofont-heart',
        'icofont icofont-heart-beat',
        'icofont icofont-history',
        'icofont icofont-home',
        'icofont icofont-horn',
        'icofont icofont-hotel',
        'icofont icofont-hour-glass',
        'icofont icofont-id',
        'icofont icofont-image',
        'icofont icofont-inbox',
        'icofont icofont-infinite',
        'icofont icofont-info',
        'icofont icofont-info-circle',
        'icofont icofont-info-square',
        'icofont icofont-institution',
        'icofont icofont-interface',
        'icofont icofont-invisible',
        'icofont icofont-italic',
        'icofont icofont-jacket',
        'icofont icofont-jar',
        'icofont icofont-jewlery',
        'icofont icofont-karate',
        'icofont icofont-key',
        'icofont icofont-key-hole',
        'icofont icofont-keyboard',
        'icofont icofont-kid',
        'icofont icofont-label',
        'icofont icofont-lamp',
        'icofont icofont-laptop',
        'icofont icofont-layers',
        'icofont icofont-layout',
        'icofont icofont-leaf',
        'icofont icofont-leaflet',
        'icofont icofont-learn',
        'icofont icofont-legal',
        'icofont icofont-lego',
        'icofont icofont-lemon',
        'icofont icofont-lens',
        'icofont icofont-letter',
        'icofont icofont-letterbox',
        'icofont icofont-library',
        'icofont icofont-license',
        'icofont icofont-life-bouy',
        'icofont icofont-life-buoy',
        'icofont icofont-life-jacket',
        'icofont icofont-life-ring',
        'icofont icofont-light-bulb',
        'icofont icofont-lighter',
        'icofont icofont-lightning-ray',
        'icofont icofont-like',
        'icofont icofont-link',
        'icofont icofont-live-support',
        'icofont icofont-location-arrow',
        'icofont icofont-location-pin',
        'icofont icofont-lock',
        'icofont icofont-login',
        'icofont icofont-logout',
        'icofont icofont-lollipop',
        'icofont icofont-look',
        'icofont icofont-loop',
        'icofont icofont-luggage',
        'icofont icofont-lunch',
        'icofont icofont-lungs',
        'icofont icofont-magic',
        'icofont icofont-magic-alt',
        'icofont icofont-magnet',
        'icofont icofont-mail',
        'icofont icofont-mail-box',
        'icofont icofont-male',
        'icofont icofont-map',
        'icofont icofont-math',
        'icofont icofont-maximize',
        'icofont icofont-measure',
        'icofont icofont-medal',
        'icofont icofont-medical',
        'icofont icofont-medicine',
        'icofont icofont-mega-phone',
        'icofont icofont-memorial',
        'icofont icofont-memory-card',
        'icofont icofont-mic',
        'icofont icofont-mic-mute',
        'icofont icofont-micro-chip',
        'icofont icofont-microphone',
        'icofont icofont-microscope',
        'icofont icofont-military',
        'icofont icofont-mill',
        'icofont icofont-minus',
        'icofont icofont-minus-circle',
        'icofont icofont-minus-square',
        'icofont icofont-mobile-phone',
        'icofont icofont-molecule',
        'icofont icofont-money',
        'icofont icofont-moon',
        'icofont icofont-mop',
        'icofont icofont-muffin',
        'icofont icofont-music',
        'icofont icofont-music-alt',
        'icofont icofont-music-notes',
        'icofont icofont-mustache',
        'icofont icofont-mute-volume',
        'icofont icofont-navigation',
        'icofont icofont-navigation-menu',
        'icofont icofont-network',
        'icofont icofont-network-tower',
        'icofont icofont-news',
        'icofont icofont-newspaper',
        'icofont icofont-no-smoking',
        'icofont icofont-not-allowed',
        'icofont icofont-notebook',
        'icofont icofont-notepad',
        'icofont icofont-notification',
        'icofont icofont-numbered',
        'icofont icofont-opposite',
        'icofont icofont-optic',
        'icofont icofont-options',
        'icofont icofont-package',
        'icofont icofont-page',
        'icofont icofont-paint',
        'icofont icofont-paper-plane',
        'icofont icofont-paperclip',
        'icofont icofont-papers',
        'icofont icofont-paw',
        'icofont icofont-pay',
        'icofont icofont-pen',
        'icofont icofont-pencil',
        'icofont icofont-penguin-linux',
        'icofont icofont-pestle',
        'icofont icofont-phone',
        'icofont icofont-phone-circle',
        'icofont icofont-picture',
        'icofont icofont-pie',
        'icofont icofont-pine',
        'icofont icofont-pixels',
        'icofont icofont-play',
        'icofont icofont-plugin',
        'icofont icofont-plus',
        'icofont icofont-plus-circle',
        'icofont icofont-plus-square',
        'icofont icofont-polygonal',
        'icofont icofont-power',
        'icofont icofont-presentation',
        'icofont icofont-price',
        'icofont icofont-print',
        'icofont icofont-puzzle',
        'icofont icofont-qr-code',
        'icofont icofont-queen',
        'icofont icofont-question',
        'icofont icofont-question-circle',
        'icofont icofont-question-square',
        'icofont icofont-quote-left',
        'icofont icofont-quote-right',
        'icofont icofont-radio',
        'icofont icofont-random',
        'icofont icofont-recycle',
        'icofont icofont-refresh',
        'icofont icofont-repair',
        'icofont icofont-reply',
        'icofont icofont-reply-all',
        'icofont icofont-resize',
        'icofont icofont-responsive',
        'icofont icofont-retweet',
        'icofont icofont-road',
        'icofont icofont-robot',
        'icofont icofont-rocket',
        'icofont icofont-royal',
        'icofont icofont-rss-feed',
        'icofont icofont-safety',
        'icofont icofont-sale-discount',
        'icofont icofont-satellite',
        'icofont icofont-send-mail',
        'icofont icofont-server',
        'icofont icofont-settings',
        'icofont icofont-share',
        'icofont icofont-share-alt',
        'icofont icofont-share-boxed',
        'icofont icofont-shield',
        'icofont icofont-ship',
        'icofont icofont-shopping-cart',
        'icofont icofont-sign-in',
        'icofont icofont-sign-out',
        'icofont icofont-signal',
        'icofont icofont-site-map',
        'icofont icofont-smart-phone',
        'icofont icofont-soccer',
        'icofont icofont-sort',
        'icofont icofont-sort-alt',
        'icofont icofont-space',
        'icofont icofont-spanner',
        'icofont icofont-speech-comments',
        'icofont icofont-speed-meter',
        'icofont icofont-spinner',
        'icofont icofont-spinner-alt-1',
        'icofont icofont-spinner-alt-2',
        'icofont icofont-spinner-alt-3',
        'icofont icofont-spinner-alt-4',
        'icofont icofont-spinner-alt-5',
        'icofont icofont-spinner-alt-6',
        'icofont icofont-spreadsheet',
        'icofont icofont-square',
        'icofont icofont-ssl-security',
        'icofont icofont-star',
        'icofont icofont-star-alt-1',
        'icofont icofont-star-alt-2',
        'icofont icofont-street-view',
        'icofont icofont-sun',
        'icofont icofont-support-faq',
        'icofont icofont-tack-pin',
        'icofont icofont-tag',
        'icofont icofont-tags',
        'icofont icofont-tasks',
        'icofont icofont-telephone',
        'icofont icofont-telescope',
        'icofont icofont-terminal',
        'icofont icofont-thumbs-down',
        'icofont icofont-thumbs-up',
        'icofont icofont-tick-boxed',
        'icofont icofont-tick-mark',
        'icofont icofont-ticket',
        'icofont icofont-tie',
        'icofont icofont-toggle-off',
        'icofont icofont-toggle-on',
        'icofont icofont-tools',
        'icofont icofont-transparent',
        'icofont icofont-tree',
        'icofont icofont-umbrella',
        'icofont icofont-unlock',
        'icofont icofont-unlocked',
        'icofont icofont-upload',
        'icofont icofont-upload-alt',
        'icofont icofont-usb',
        'icofont icofont-usb-drive',
        'icofont icofont-vector-path',
        'icofont icofont-verification-check',
        'icofont icofont-video',
        'icofont icofont-video-clapper',
        'icofont icofont-volume-down',
        'icofont icofont-volume-off',
        'icofont icofont-volume-up',
        'icofont icofont-wall',
        'icofont icofont-wall-clock',
        'icofont icofont-wallet',
        'icofont icofont-warning',
        'icofont icofont-warning-alt',
        'icofont icofont-water-drop',
        'icofont icofont-web',
        'icofont icofont-wheelchair',
        'icofont icofont-wifi',
        'icofont icofont-wifi-alt',
        'icofont icofont-world',
        'icofont icofont-zigzag',
        'icofont icofont-zipped',
        'fa fa-address-book',
        'fa fa-address-book-o',
        'fa fa-address-card',
        'fa fa-address-card-o',
        'fa fa-adjust',
        'fa fa-align-center',
        'fa fa-align-justify',
        'fa fa-align-left',
        'fa fa-align-right',
        'fa fa-ambulance',
        'fa fa-american-sign-language-interpreting',
        'fa fa-anchor',
        'fa fa-angle-double-down',
        'fa fa-angle-double-left',
        'fa fa-angle-double-right',
        'fa fa-angle-double-up',
        'fa fa-angle-down',
        'fa fa-angle-left',
        'fa fa-angle-right',
        'fa fa-angle-up',
        'fa fa-archive',
        'fa fa-area-chart',
        'fa fa-arrow-circle-down',
        'fa fa-arrow-circle-left',
        'fa fa-arrow-circle-o-down',
        'fa fa-arrow-circle-o-left',
        'fa fa-arrow-circle-o-right',
        'fa fa-arrow-circle-o-up',
        'fa fa-arrow-circle-right',
        'fa fa-arrow-circle-up',
        'fa fa-arrow-down',
        'fa fa-arrow-left',
        'fa fa-arrow-right',
        'fa fa-arrow-up',
        'fa fa-arrows',
        'fa fa-arrows-alt',
        'fa fa-arrows-h',
        'fa fa-arrows-v',
        'fa fa-asl-interpreting',
        'fa fa-assistive-listening-systems',
        'fa fa-asterisk',
        'fa fa-at',
        'fa fa-audio-description',
        'fa fa-automobile',
        'fa fa-backward',
        'fa fa-balance-scale',
        'fa fa-ban',
        'fa fa-bank',
        'fa fa-bar-chart',
        'fa fa-bar-chart-o',
        'fa fa-barcode',
        'fa fa-bars',
        'fa fa-bathtub',
        'fa fa-battery',
        'fa fa-battery-0',
        'fa fa-battery-1',
        'fa fa-battery-2',
        'fa fa-battery-3',
        'fa fa-battery-4',
        'fa fa-battery-empty',
        'fa fa-battery-full',
        'fa fa-battery-half',
        'fa fa-battery-quarter',
        'fa fa-battery-three-quarters',
        'fa fa-bed',
        'fa fa-beer',
        'fa fa-bell',
        'fa fa-bell-o',
        'fa fa-bell-slash',
        'fa fa-bell-slash-o',
        'fa fa-bicycle',
        'fa fa-binoculars',
        'fa fa-birthday-cake',
        'fa fa-blind',
        'fa fa-bold',
        'fa fa-bolt',
        'fa fa-bomb',
        'fa fa-book',
        'fa fa-bookmark',
        'fa fa-bookmark-o',
        'fa fa-braille',
        'fa fa-briefcase',
        'fa fa-bug',
        'fa fa-building',
        'fa fa-building-o',
        'fa fa-bullhorn',
        'fa fa-bullseye',
        'fa fa-bus',
        'fa fa-cab',
        'fa fa-calculator',
        'fa fa-calendar',
        'fa fa-calendar-check-o',
        'fa fa-calendar-minus-o',
        'fa fa-calendar-o',
        'fa fa-calendar-plus-o',
        'fa fa-calendar-times-o',
        'fa fa-camera',
        'fa fa-camera-retro',
        'fa fa-car',
        'fa fa-caret-down',
        'fa fa-caret-left',
        'fa fa-caret-right',
        'fa fa-caret-square-o-down',
        'fa fa-caret-square-o-left',
        'fa fa-caret-square-o-right',
        'fa fa-caret-square-o-up',
        'fa fa-caret-up',
        'fa fa-cart-arrow-down',
        'fa fa-cart-plus',
        'fa fa-cc',
        'fa fa-certificate',
        'fa fa-chain',
        'fa fa-chain-broken',
        'fa fa-check',
        'fa fa-check-circle',
        'fa fa-check-circle-o',
        'fa fa-check-square',
        'fa fa-check-square-o',
        'fa fa-chevron-circle-down',
        'fa fa-chevron-circle-left',
        'fa fa-chevron-circle-right',
        'fa fa-chevron-circle-up',
        'fa fa-chevron-down',
        'fa fa-chevron-left',
        'fa fa-chevron-right',
        'fa fa-chevron-up',
        'fa fa-child',
        'fa fa-circle',
        'fa fa-circle-o',
        'fa fa-circle-o-notch',
        'fa fa-circle-thin',
        'fa fa-clipboard',
        'fa fa-clock-o',
        'fa fa-clone',
        'fa fa-close',
        'fa fa-cloud',
        'fa fa-cloud-download',
        'fa fa-cloud-upload',
        'fa fa-cny',
        'fa fa-code',
        'fa fa-code-fork',
        'fa fa-coffee',
        'fa fa-cog',
        'fa fa-cogs',
        'fa fa-columns',
        'fa fa-comment',
        'fa fa-comment-o',
        'fa fa-commenting',
        'fa fa-commenting-o',
        'fa fa-comments',
        'fa fa-comments-o',
        'fa fa-compass',
        'fa fa-compress',
        'fa fa-copy',
        'fa fa-copyright',
        'fa fa-creative-commons',
        'fa fa-credit-card',
        'fa fa-credit-card-alt',
        'fa fa-crop',
        'fa fa-crosshairs',
        'fa fa-cube',
        'fa fa-cubes',
        'fa fa-cut',
        'fa fa-cutlery',
        'fa fa-dashboard',
        'fa fa-database',
        'fa fa-deaf',
        'fa fa-deafness',
        'fa fa-dedent',
        'fa fa-desktop',
        'fa fa-diamond',
        'fa fa-dollar',
        'fa fa-dot-circle-o',
        'fa fa-download',
        'fa fa-drivers-license',
        'fa fa-drivers-license-o',
        'fa fa-edit',
        'fa fa-eject',
        'fa fa-ellipsis-h',
        'fa fa-ellipsis-v',
        'fa fa-envelope',
        'fa fa-envelope-o',
        'fa fa-envelope-open',
        'fa fa-envelope-open-o',
        'fa fa-envelope-square',
        'fa fa-eraser',
        'fa fa-eur',
        'fa fa-euro',
        'fa fa-exchange',
        'fa fa-exclamation',
        'fa fa-exclamation-circle',
        'fa fa-exclamation-triangle',
        'fa fa-expand',
        'fa fa-external-link',
        'fa fa-external-link-square',
        'fa fa-eye',
        'fa fa-eye-slash',
        'fa fa-eyedropper',
        'fa fa-fast-backward',
        'fa fa-fast-forward',
        'fa fa-fax',
        'fa fa-feed',
        'fa fa-female',
        'fa fa-fighter-jet',
        'fa fa-file',
        'fa fa-file-archive-o',
        'fa fa-file-audio-o',
        'fa fa-file-code-o',
        'fa fa-file-excel-o',
        'fa fa-file-image-o',
        'fa fa-file-movie-o',
        'fa fa-file-o',
        'fa fa-file-pdf-o',
        'fa fa-file-photo-o',
        'fa fa-file-picture-o',
        'fa fa-file-powerpoint-o',
        'fa fa-file-sound-o',
        'fa fa-file-text',
        'fa fa-file-text-o',
        'fa fa-file-video-o',
        'fa fa-file-word-o',
        'fa fa-file-zip-o',
        'fa fa-files-o',
        'fa fa-film',
        'fa fa-filter',
        'fa fa-fire',
        'fa fa-fire-extinguisher',
        'fa fa-flag',
        'fa fa-flag-checkered',
        'fa fa-flag-o',
        'fa fa-flash',
        'fa fa-flask',
        'fa fa-floppy-o',
        'fa fa-folder',
        'fa fa-folder-o',
        'fa fa-folder-open',
        'fa fa-folder-open-o',
        'fa fa-font',
        'fa fa-forward',
        'fa fa-frown-o',
        'fa fa-futbol-o',
        'fa fa-gamepad',
        'fa fa-gavel',
        'fa fa-gbp',
        'fa fa-gear',
        'fa fa-gears',
        'fa fa-genderless',
        'fa fa-gift',
        'fa fa-glass',
        'fa fa-globe',
        'fa fa-graduation-cap',
        'fa fa-group',
        'fa fa-h-square',
        'fa fa-hand-grab-o',
        'fa fa-hand-lizard-o',
        'fa fa-hand-o-down',
        'fa fa-hand-o-left',
        'fa fa-hand-o-right',
        'fa fa-hand-o-up',
        'fa fa-hand-paper-o',
        'fa fa-hand-peace-o',
        'fa fa-hand-pointer-o',
        'fa fa-hand-rock-o',
        'fa fa-hand-scissors-o',
        'fa fa-hand-spock-o',
        'fa fa-hand-stop-o',
        'fa fa-handshake-o',
        'fa fa-hard-of-hearing',
        'fa fa-hashtag',
        'fa fa-hdd-o',
        'fa fa-header',
        'fa fa-headphones',
        'fa fa-heart',
        'fa fa-heart-o',
        'fa fa-heartbeat',
        'fa fa-history',
        'fa fa-home',
        'fa fa-hospital-o',
        'fa fa-hotel',
        'fa fa-hourglass',
        'fa fa-hourglass-1',
        'fa fa-hourglass-2',
        'fa fa-hourglass-3',
        'fa fa-hourglass-end',
        'fa fa-hourglass-half',
        'fa fa-hourglass-o',
        'fa fa-hourglass-start',
        'fa fa-i-cursor',
        'fa fa-id-badge',
        'fa fa-id-card',
        'fa fa-id-card-o',
        'fa fa-ils',
        'fa fa-image',
        'fa fa-inbox',
        'fa fa-indent',
        'fa fa-industry',
        'fa fa-info',
        'fa fa-info-circle',
        'fa fa-inr',
        'fa fa-institution',
        'fa fa-intersex',
        'fa fa-italic',
        'fa fa-jpy',
        'fa fa-key',
        'fa fa-keyboard-o',
        'fa fa-krw',
        'fa fa-language',
        'fa fa-laptop',
        'fa fa-leaf',
        'fa fa-legal',
        'fa fa-lemon-o',
        'fa fa-level-down',
        'fa fa-level-up',
        'fa fa-life-bouy',
        'fa fa-life-buoy',
        'fa fa-life-ring',
        'fa fa-life-saver',
        'fa fa-lightbulb-o',
        'fa fa-line-chart',
        'fa fa-link',
        'fa fa-list',
        'fa fa-list-alt',
        'fa fa-list-ol',
        'fa fa-list-ul',
        'fa fa-location-arrow',
        'fa fa-lock',
        'fa fa-long-arrow-down',
        'fa fa-long-arrow-left',
        'fa fa-long-arrow-right',
        'fa fa-long-arrow-up',
        'fa fa-low-vision',
        'fa fa-magic',
        'fa fa-magnet',
        'fa fa-mail-forward',
        'fa fa-mail-reply',
        'fa fa-mail-reply-all',
        'fa fa-male',
        'fa fa-map',
        'fa fa-map-marker',
        'fa fa-map-o',
        'fa fa-map-pin',
        'fa fa-map-signs',
        'fa fa-mars',
        'fa fa-mars-double',
        'fa fa-mars-stroke',
        'fa fa-mars-stroke-h',
        'fa fa-mars-stroke-v',
        'fa fa-medkit',
        'fa fa-meh-o',
        'fa fa-mercury',
        'fa fa-microchip',
        'fa fa-microphone',
        'fa fa-microphone-slash',
        'fa fa-minus',
        'fa fa-minus-circle',
        'fa fa-minus-square',
        'fa fa-minus-square-o',
        'fa fa-mobile',
        'fa fa-mobile-phone',
        'fa fa-money',
        'fa fa-moon-o',
        'fa fa-mortar-board',
        'fa fa-motorcycle',
        'fa fa-mouse-pointer',
        'fa fa-music',
        'fa fa-navicon',
        'fa fa-neuter',
        'fa fa-newspaper-o',
        'fa fa-object-group',
        'fa fa-object-ungroup',
        'fa fa-outdent',
        'fa fa-paint-brush',
        'fa fa-paper-plane',
        'fa fa-paper-plane-o',
        'fa fa-paperclip',
        'fa fa-paragraph',
        'fa fa-paste',
        'fa fa-pause',
        'fa fa-pause-circle',
        'fa fa-pause-circle-o',
        'fa fa-paw',
        'fa fa-pencil',
        'fa fa-pencil-square',
        'fa fa-pencil-square-o',
        'fa fa-percent',
        'fa fa-phone',
        'fa fa-phone-square',
        'fa fa-photo',
        'fa fa-picture-o',
        'fa fa-pie-chart',
        'fa fa-plane',
        'fa fa-play',
        'fa fa-play-circle',
        'fa fa-play-circle-o',
        'fa fa-plug',
        'fa fa-plus',
        'fa fa-plus-circle',
        'fa fa-plus-square',
        'fa fa-plus-square-o',
        'fa fa-podcast',
        'fa fa-power-off',
        'fa fa-print',
        'fa fa-puzzle-piece',
        'fa fa-qrcode',
        'fa fa-question',
        'fa fa-question-circle',
        'fa fa-question-circle-o',
        'fa fa-quote-left',
        'fa fa-quote-right',
        'fa fa-random',
        'fa fa-recycle',
        'fa fa-refresh',
        'fa fa-registered',
        'fa fa-remove',
        'fa fa-reorder',
        'fa fa-repeat',
        'fa fa-reply',
        'fa fa-reply-all',
        'fa fa-retweet',
        'fa fa-rmb',
        'fa fa-road',
        'fa fa-rocket',
        'fa fa-rotate-left',
        'fa fa-rotate-right',
        'fa fa-rouble',
        'fa fa-rss',
        'fa fa-rss-square',
        'fa fa-rub',
        'fa fa-ruble',
        'fa fa-rupee',
        'fa fa-s15',
        'fa fa-save',
        'fa fa-scissors',
        'fa fa-search',
        'fa fa-search-minus',
        'fa fa-search-plus',
        'fa fa-send',
        'fa fa-send-o',
        'fa fa-server',
        'fa fa-share',
        'fa fa-share-square',
        'fa fa-share-square-o',
        'fa fa-shekel',
        'fa fa-sheqel',
        'fa fa-shield',
        'fa fa-ship',
        'fa fa-shopping-bag',
        'fa fa-shopping-basket',
        'fa fa-shopping-cart',
        'fa fa-shower',
        'fa fa-sign-in',
        'fa fa-sign-language',
        'fa fa-sign-out',
        'fa fa-signal',
        'fa fa-signing',
        'fa fa-sitemap',
        'fa fa-sliders',
        'fa fa-smile-o',
        'fa fa-snowflake-o',
        'fa fa-soccer-ball-o',
        'fa fa-sort',
        'fa fa-sort-alpha-asc',
        'fa fa-sort-alpha-desc',
        'fa fa-sort-amount-asc',
        'fa fa-sort-amount-desc',
        'fa fa-sort-asc',
        'fa fa-sort-desc',
        'fa fa-sort-down',
        'fa fa-sort-numeric-asc',
        'fa fa-sort-numeric-desc',
        'fa fa-sort-up',
        'fa fa-space-shuttle',
        'fa fa-spinner',
        'fa fa-spoon',
        'fa fa-square',
        'fa fa-square-o',
        'fa fa-star',
        'fa fa-star-half',
        'fa fa-star-half-empty',
        'fa fa-star-half-full',
        'fa fa-star-half-o',
        'fa fa-star-o',
        'fa fa-step-backward',
        'fa fa-step-forward',
        'fa fa-stethoscope',
        'fa fa-sticky-note',
        'fa fa-sticky-note-o',
        'fa fa-stop',
        'fa fa-stop-circle',
        'fa fa-stop-circle-o',
        'fa fa-street-view',
        'fa fa-strikethrough',
        'fa fa-subscript',
        'fa fa-subway',
        'fa fa-suitcase',
        'fa fa-sun-o',
        'fa fa-superscript',
        'fa fa-support',
        'fa fa-table',
        'fa fa-tablet',
        'fa fa-tachometer',
        'fa fa-tag',
        'fa fa-tags',
        'fa fa-tasks',
        'fa fa-taxi',
        'fa fa-television',
        'fa fa-terminal',
        'fa fa-text-height',
        'fa fa-text-width',
        'fa fa-th',
        'fa fa-th-large',
        'fa fa-th-list',
        'fa fa-thermometer',
        'fa fa-thermometer-0',
        'fa fa-thermometer-1',
        'fa fa-thermometer-2',
        'fa fa-thermometer-3',
        'fa fa-thermometer-4',
        'fa fa-thermometer-empty',
        'fa fa-thermometer-full',
        'fa fa-thermometer-half',
        'fa fa-thermometer-quarter',
        'fa fa-thermometer-three-quarters',
        'fa fa-thumb-tack',
        'fa fa-thumbs-down',
        'fa fa-thumbs-o-down',
        'fa fa-thumbs-o-up',
        'fa fa-thumbs-up',
        'fa fa-ticket',
        'fa fa-times',
        'fa fa-times-circle',
        'fa fa-times-circle-o',
        'fa fa-times-rectangle',
        'fa fa-times-rectangle-o',
        'fa fa-tint',
        'fa fa-toggle-down',
        'fa fa-toggle-left',
        'fa fa-toggle-off',
        'fa fa-toggle-on',
        'fa fa-toggle-right',
        'fa fa-toggle-up',
        'fa fa-trademark',
        'fa fa-train',
        'fa fa-transgender',
        'fa fa-transgender-alt',
        'fa fa-trash',
        'fa fa-trash-o',
        'fa fa-tree',
        'fa fa-trophy',
        'fa fa-truck',
        'fa fa-try',
        'fa fa-tty',
        'fa fa-turkish-lira',
        'fa fa-tv',
        'fa fa-umbrella',
        'fa fa-underline',
        'fa fa-undo',
        'fa fa-universal-access',
        'fa fa-university',
        'fa fa-unlink',
        'fa fa-unlock',
        'fa fa-unlock-alt',
        'fa fa-unsorted',
        'fa fa-upload',
        'fa fa-usd',
        'fa fa-user',
        'fa fa-user-circle',
        'fa fa-user-circle-o',
        'fa fa-user-md',
        'fa fa-user-o',
        'fa fa-user-plus',
        'fa fa-user-secret',
        'fa fa-user-times',
        'fa fa-users',
        'fa fa-vcard',
        'fa fa-vcard-o',
        'fa fa-venus',
        'fa fa-venus-double',
        'fa fa-venus-mars',
        'fa fa-video-camera',
        'fa fa-volume-control-phone',
        'fa fa-volume-down',
        'fa fa-volume-off',
        'fa fa-volume-up',
        'fa fa-warning',
        'fa fa-wheelchair',
        'fa fa-wheelchair-alt',
        'fa fa-wifi',
        'fa fa-window-close',
        'fa fa-window-close-o',
        'fa fa-window-maximize',
        'fa fa-window-minimize',
        'fa fa-window-restore',
        'fa fa-won',
        'fa fa-wrench',
        'fa fa-yen'
      ]
    }
  },
  mounted () {
    let thatObject = this
    $('#fontCompany').higooglefonts({
      placeholder: 'Typographie',
      loadedCallback (e) {
        thatObject.fontCompany = e
      },
      selectedCallback (e) {
        thatObject.fontCompany = e
      }
    })
    $('#fontSlogan').higooglefonts({
      placeholder: 'Typographie',
      loadedCallback (e) {
        thatObject.fontSlogan = e
      },
      selectedCallback (e) {
        thatObject.fontSlogan = e
      }
    })
    this.adjustWorkspace()
  },
  watch: {
    company () {
      this.adjustWorkspace()
    },
    slogan (newSlogan) {
      this.adjustWorkspace()
      if (newSlogan.length < 1) {
        $('#logo-oven .company').addClass('alone')
      } else {
        $('#logo-oven .company').removeClass('alone')
      }
    },
    fontSlogan () {
      this.adjustWorkspace()
    },
    fontCompany () {
      this.adjustWorkspace()
    }
  },
  methods: {
    save (divId) {
      let _this = this
      _this.wait = true
      setTimeout(() => {
        let company = _this.company
        let elt = document.getElementById(divId)
        let currentClasses = (elt.classList + ' ').trim()
        elt.classList += ' save'
        _this.adjustWorkspace()
        html2canvas(elt, {
          backgroundColor: null
        }).then((canvas) => {
          document.body.appendChild(canvas)
          let a = document.createElement('a')
          let url = canvas.toDataURL('image/png')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.href = url
          a.download = company.replace(/[^a-zA-Z0-9]/, '-').toLowerCase() + '-logo.png'
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(canvas)
          document.body.removeChild(a)
          elt.classList = currentClasses
          _this.adjustWorkspace()
          _this.wait = false
        })
      }, 10)
    },
    adjustWorkspace () {
      let companyWidth = $('#logo-oven .company').outerWidth()
      let sloganWidth = $('#logo-oven .slogan').outerWidth()
      let logoWidth = $('#logo-oven i').outerWidth()
      let minWidth = logoWidth + Math.max(companyWidth, sloganWidth) + 120
      $('#logo-oven').css('min-width', minWidth)
    }
  }
}
</script>

<style lang="scss" scoped>

  *{
    font-family: 'Source Sans Pro', sans-serif;
  }

  .logo{
    text-align: center;
    margin: 30px 0 30px 0;
  }

  .logo img{
    width: 100%;
    max-width: 200px;
  }

  .logo h1{
    font-size: 22px;
    font-weight: normal;
    letter-spacing: -1.3px;
  }

  .sidebar{
    padding-bottom: 15px;
  }

  @media(min-width: 768px){
    .sidebar{
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      z-index: 1000;
      overflow-x: hidden;
      overflow-y: auto;
      border-right: 1px solid #eee;
    }
  }

  .small-margin{
    height: 15px;
  }

  .color.form-control{
    padding:0;
    height: 35px;
  }

  .font-select{
    width: 100%;
    font-size: 1rem;
    line-height: 1.25;
    border-radius: .25rem;
  }

  .font-select a{
    font-size: 0.9rem;
    line-height: 1.25;
    padding: .5rem .75rem;
    height: 38px;
    background: #fff;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: .25rem;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  }


  .font-select a:active,
  .form-control:focus,
  .form-control:active{
    background-color: #fff;
    border-color: #84B44C;
    outline: 0;
  }

  .font-select .fs-drop{
    border: 1px solid rgba(0,0,0,.15);
    border-radius: .25rem;
    top: 37px;
  }

  .btn-primary{
    background: #84B44C;
    border: 1px solid #84B44C;
    border-radius: 0;
  }
  a.btn-primary:focus,
  a.btn-primary:active,
  a.btn-primary:hover{
    color: #84B44C;
    border: 1px solid #84B44C;
    background: #fff;
  }

  .gradient-pattern {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    border: none;
    font: normal 100%/normal Arial, Helvetica, sans-serif;
    color: rgba(255,255,255,1);
    -o-text-overflow: clip;
    text-overflow: clip;
    background: -webkit-linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0), -webkit-linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0);
    background: -moz-linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0), -moz-linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0);
    background: linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0), linear-gradient(45deg, rgba(0,0,0,0.02) 25%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 75%, rgba(0,0,0,0.02) 75%, rgba(0,0,0,0.02) 0);
    background-position: 0 0, 25px 25px;
    -webkit-background-origin: padding-box;
    background-origin: padding-box;
    -webkit-background-clip: border-box;
    background-clip: border-box;
    -webkit-background-size: 50px 50px;
    background-size: 50px 50px;
  }

  .gradient-pattern > div{
    color: #000;
  }

  .workspace{
    padding-top: 15px;
    min-height: 50vh;
    overflow-x: auto;
  }
  @media(min-width: 768px){
    .workspace{
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

.logo-frame{
  height: 310px;
  overflow: auto;
  background: #fff;
  border: 1px solid #eee;
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
    margin: 5px;
    display: inline-block;
    width: 75px;
    height: 75px;
    text-align: center;
    font-size: 2px;
    color: #fff;
    position: relative;
    i{
      font-size: 50px;
      color: #000;
      display: block;
      margin: 5px;
    }
    input{
      position: absolute;
      opacity: 0;
    }
    label:active{
      i{
        color: #666;
      }
    }
  }
}

#logo-oven {
  transform: scale(1);
  
  white-space: nowrap;
}

#logo-oven.center {
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

#logo-oven.left {
  padding: 15px;
  display: inline-block;
  text-align: left;
  i.icofont,
  i.fa {
    float: left;
    margin-right: 25px;
  }
}

i.fa {
  font-family: FontAwesome !important;
}

#logo-oven.right {
  padding: 15px;
  display: inline-block;
  text-align: right;
  i.icofont,
  i.fa {
    float: right;
    margin-left: 25px;
  }
}

.company {
  display: inline-block;
  font-size: 60px;
  line-height: 50px;
  white-space: nowrap;
}

.company.alone {
  font-size: 80px;
  line-height: 80px;
  height: 100px;
}

.save .company {
  font-size: 240px;
  line-height: 200px;
}

.save .company.alone {
  font-size: 320px;
  line-height: 320px;
  height: 400px;
}

.slogan {
  display: inline-block;
  font-size: 25px;
  white-space: nowrap;
  margin-top: 5px;
}

.save .slogan {
  font-size: 100px;
}

.save i {
  font-size: 20em;
}

#wait {
  display: flex;
  background: #CFCFCF;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #acacac;
  z-index: 99999999999;
  font-size: 100px;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// Logo.vue?9486c214